(function () {
  if (window.__dcodedCartPromoInit) return;
  window.__dcodedCartPromoInit = true;

  const getPromoFromNode = (node) => node?.closest?.('dcoded-cart-promo') || null;

  let activePromo = null;

  const getActivePromo = () => {
    if (activePromo?.isConnected) return activePromo;
    activePromo = document.querySelector('cart-drawer dcoded-cart-promo') || document.querySelector('dcoded-cart-promo');
    return activePromo;
  };

  const PROMO_OUTSIDE_CLICK_SELECTOR = [
    '[data-promo-sheet]',
    '[data-promo-overlay]',
    '[data-promo-form]',
    '[data-promo-apply]',
    '[data-tap-code]',
    '[data-promo-close]',
    '[data-promo-remove]',
    '[data-promo-change]',
    '[data-promo-trigger]',
    '.dcoded-promo__input',
    '.dcoded-promo__inline'
  ].join(',');

  const isPromoOutsideClickTarget = (target) => {
    if (!target) return false;
    if (target.closest?.(PROMO_OUTSIDE_CLICK_SELECTOR)) return true;

    const drawer = target.closest?.('cart-drawer') || (target.matches?.('cart-drawer') ? target : null);
    if (drawer?.querySelector?.('[data-promo-remove], [data-promo-change], [data-promo-trigger], .dcoded-promo__inline')) {
      return true;
    }

    return false;
  };

  const getPromoFromEvent = (e) => {
    for (const node of e.composedPath()) {
      if (node instanceof Element && node.matches?.('dcoded-cart-promo')) {
        return node;
      }
    }
    return null;
  };

  const handleDrawerPromoClick = (e) => {
    const removeBtn = findInComposedPath(e, '[data-promo-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const promo = removeBtn.closest('dcoded-cart-promo') || getPromoFromEvent(e);
      promo?._removeCode?.();
      return;
    }

    const changeBtn = findInComposedPath(e, '[data-promo-change]');
    const triggerBtn = findInComposedPath(e, '[data-promo-trigger]');
    if (changeBtn || triggerBtn) {
      e.preventDefault();
      e.stopPropagation();
      const promo =
        (changeBtn || triggerBtn).closest('dcoded-cart-promo') || getPromoFromEvent(e);
      promo?._openSheet?.();
    }
  };

  const bindDrawerPromoClicks = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer._dcodedPromoCaptureHandler) {
      drawer.removeEventListener('click', drawer._dcodedPromoCaptureHandler, true);
    }

    drawer._dcodedPromoCaptureHandler = handleDrawerPromoClick;
    drawer.addEventListener('click', drawer._dcodedPromoCaptureHandler, true);
  };

  const patchCartDrawerOutsideClick = () => {
    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype._dcodedPromoPatched) return;

    const originalHide = CartDrawer.prototype.hideForOutsideClickTarget;
    CartDrawer.prototype.hideForOutsideClickTarget = function (target) {
      if (isPromoOutsideClickTarget(target)) return false;
      return originalHide.call(this, target);
    };

    const originalAllow = CartDrawer.prototype.allowOutsideClickForTarget;
    CartDrawer.prototype.allowOutsideClickForTarget = function (target) {
      if (isPromoOutsideClickTarget(target)) return true;
      return originalAllow.call(this, target);
    };

    CartDrawer.prototype._dcodedPromoPatched = true;
  };

  patchCartDrawerOutsideClick();
  customElements.whenDefined('cart-drawer').then(patchCartDrawerOutsideClick);

  const bindCartDrawerLifecycle = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer._dcodedPromoLifecycleBound) return;
    drawer._dcodedPromoLifecycleBound = true;

    drawer.addEventListener('dialog:before-hide', () => {
      drawer.querySelectorAll('dcoded-cart-promo').forEach((promo) => promo._forceCloseSheet());
      activePromo = null;
    });

    drawer.addEventListener('dialog:after-show', () => {
      activePromo = null;
      drawer.querySelectorAll('dcoded-cart-promo').forEach((promo) => promo._reclaimSheetNodes());
    });
  };

  const onCartDrawerRefreshed = () => {
    bindCartDrawerLifecycle();
    bindDrawerPromoClicks();
    document.querySelectorAll('cart-drawer dcoded-cart-promo').forEach((promo) => {
      promo._reclaimSheetNodes?.();
      if (!promo._boundClick) {
        promo._boundClick = promo._handleClick?.bind(promo);
        if (promo._boundClick) promo.addEventListener('click', promo._boundClick);
      }
    });
  };

  bindCartDrawerLifecycle();
  customElements.whenDefined('cart-drawer').then(() => {
    bindCartDrawerLifecycle();
    bindDrawerPromoClicks();
  });
  bindDrawerPromoClicks();
  document.addEventListener('cart-drawer:refreshed', onCartDrawerRefreshed);

  window.dcodedPromoRemove = (button) => {
    const promo = button?.closest?.('dcoded-cart-promo');
    if (promo?._removeCode) {
      promo._removeCode();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    const fallback = drawer?.querySelector('dcoded-cart-promo');
    fallback?._removeCode?.();
  };

  const formatMoney = (cents) => {
    const format = window.themeVariables?.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const normalizeCode = (value) => (value || '').trim().toLowerCase();

  const normalizePlanName = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const parsePlanMapFromElement = (el) => {
    const script = el?.querySelector('[data-subscribe-plans]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || '{}');
    } catch {
      return {};
    }
  };

  const getSinglePackPlanId = (variantId, currentPlanId) => {
    for (const el of document.querySelectorAll('dcoded-cart-subscribe-save')) {
      const plans = parsePlanMapFromElement(el)[String(variantId)];
      const planId = pickSinglePackPlanId(plans, currentPlanId);
      if (planId) return planId;
    }

    return null;
  };

  const pickSinglePackPlanId = (plans, currentPlanId) => {
    if (!plans?.length) return null;

    const pack1 = plans.find((plan) => normalizePlanName(plan.name).includes('1 pack'));
    if (pack1) return String(pack1.id);

    const notPack3 = plans.find((plan) => {
      if (currentPlanId && String(plan.id) === String(currentPlanId)) return false;
      return !normalizePlanName(plan.name).includes('3 pack');
    });
    if (notPack3) return String(notPack3.id);

    if (currentPlanId) {
      const alternate = plans.find((plan) => String(plan.id) !== String(currentPlanId));
      if (alternate) return String(alternate.id);
    }

    return null;
  };

  const findInComposedPath = (e, selector) => {
    for (const node of e.composedPath()) {
      if (node instanceof Element && node.matches?.(selector)) {
        return node;
      }
    }
    return null;
  };

  const getPlansForVariant = (variantId) => {
    for (const el of document.querySelectorAll('dcoded-cart-subscribe-save')) {
      const plans = parsePlanMapFromElement(el)[String(variantId)];
      if (plans?.length) return plans;
    }
    return [];
  };

  const resolvePromoFromAction = (actionEl, e) =>
    actionEl?.closest?.('dcoded-cart-promo') ||
    getPromoFromEvent(e) ||
    document.querySelector('cart-drawer dcoded-cart-promo') ||
    document.querySelector('dcoded-cart-promo');

  const handlePromoAction = (e) => {
    const removeBtn = findInComposedPath(e, '[data-promo-remove]');
    if (removeBtn) {
      if (removeBtn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      resolvePromoFromAction(removeBtn, e)?._removeCode?.();
      return;
    }

    const changeBtn = findInComposedPath(e, '[data-promo-change]');
    const triggerBtn = findInComposedPath(e, '[data-promo-trigger]');
    if (changeBtn || triggerBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      resolvePromoFromAction(changeBtn || triggerBtn, e)?._openSheet?.();
    }
  };

  document.addEventListener('click', handlePromoAction, true);

  class DcodedCartPromo extends HTMLElement {
    disconnectedCallback() {
      // Cart drawer reparents this element when it closes. Force-close restores
      // the sheet/overlay as children so they move with the host. Do not .remove()
      // them — that permanently destroys the UI until a full cart refresh.
      this._forceCloseSheet();
      this._overlay = null;
      this._sheet = null;
      this._portaled = false;
      if (this._boundClick) {
        this.removeEventListener('click', this._boundClick);
      }
      if (activePromo === this) activePromo = null;
    }

    _resetSheetRefs() {
      this._overlay = null;
      this._sheet = null;
      this._portaled = false;
    }

    _bindPortaledNodes(overlay, sheet) {
      overlay._dcodedPromo = this;
      sheet._dcodedPromo = this;
    }

    _restoreSheetToHost() {
      if (this._overlay && this._overlay.parentElement !== this) {
        this.appendChild(this._overlay);
      }
      if (this._sheet && this._sheet.parentElement !== this) {
        this.appendChild(this._sheet);
      }
      this._portaled = false;
    }

    _reclaimSheetNodes() {
      const hostOverlay = this.querySelector('[data-promo-overlay]');
      const hostSheet = this.querySelector('[data-promo-sheet]');

      if (hostOverlay) this._overlay = hostOverlay;
      if (hostSheet) this._sheet = hostSheet;

      if (!this._overlay) {
        const bodyOverlay = Array.from(document.querySelectorAll('[data-promo-overlay]')).find(
          (el) => el._dcodedPromo === this
        );
        if (bodyOverlay) {
          this._overlay = bodyOverlay;
          this.appendChild(bodyOverlay);
        }
      }

      if (!this._sheet) {
        const bodySheet = Array.from(document.querySelectorAll('[data-promo-sheet]')).find(
          (el) => el._dcodedPromo === this
        );
        if (bodySheet) {
          this._sheet = bodySheet;
          this.appendChild(bodySheet);
        }
      }

      if (this._overlay && this._sheet) {
        this._bindPortaledNodes(this._overlay, this._sheet);
      }

      this._portaled = false;
      this._overlay?.classList.remove('dcoded-promo__overlay--visible');
      this._sheet?.classList.remove('dcoded-promo__sheet--open');
    }

    _resetPortaledStyles() {
      if (this._overlay) {
        Object.assign(this._overlay.style, {
          top: '',
          left: '',
          width: '',
          height: '',
          right: '',
          bottom: ''
        });
      }

      if (this._sheet) {
        Object.assign(this._sheet.style, {
          left: '',
          width: '',
          bottom: '',
          right: '',
          maxHeight: ''
        });
      }
    }

    _forceCloseSheet() {
      this._unbindReposition();
      this._overlay?.classList.remove('dcoded-promo__overlay--visible');
      this._sheet?.classList.remove('dcoded-promo__sheet--open');
      this._resetPortaledStyles();
      this._restoreSheetToHost();
      if (activePromo === this) activePromo = null;
    }

    _getCartDrawer() {
      return this.closest('cart-drawer') || document.querySelector('cart-drawer');
    }

    _getDrawerPanelRect() {
      const drawer = this._getCartDrawer();
      if (!drawer) return null;

      const panel = typeof drawer.getShadowPartByName === 'function'
        ? drawer.getShadowPartByName('content')
        : drawer.shadowRoot?.querySelector('[part="content"]');

      return (panel || drawer).getBoundingClientRect();
    }

    _positionInDrawer() {
      if (!this._overlay || !this._sheet) return;

      const rect = this._getDrawerPanelRect();
      if (!rect) return;
      const bottomOffset = Math.max(0, window.innerHeight - rect.bottom);

      Object.assign(this._overlay.style, {
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        right: 'auto',
        bottom: 'auto'
      });

      Object.assign(this._sheet.style, {
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        bottom: `${bottomOffset}px`,
        right: 'auto',
        maxHeight: `${Math.min(rect.height * 0.75, 420)}px`
      });
    }

    _bindReposition() {
      if (this._repositionHandler) return;
      this._repositionHandler = () => {
        if (this._sheet?.classList.contains('dcoded-promo__sheet--open')) {
          this._positionInDrawer();
        }
      };
      window.addEventListener('resize', this._repositionHandler);
      window.addEventListener('scroll', this._repositionHandler, true);
    }

    _unbindReposition() {
      if (!this._repositionHandler) return;
      window.removeEventListener('resize', this._repositionHandler);
      window.removeEventListener('scroll', this._repositionHandler, true);
      this._repositionHandler = null;
    }

    connectedCallback() {
      this._sectionId = this.dataset.sectionId || '';
      this._boundClick = this._boundClick || this._handleClick.bind(this);
      this.addEventListener('click', this._boundClick);
      this._reclaimSheetNodes();

      if (this.dataset.appliedCode && sessionStorage.getItem('dcoded-promo-just-applied')) {
        sessionStorage.removeItem('dcoded-promo-just-applied');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this._playApplyAnimation());
        });
      }
    }

    _handleClick(e) {
      if (e.target.closest('[data-promo-remove]')) {
        e.preventDefault();
        e.stopPropagation();
        this._removeCode();
        return;
      }

      if (e.target.closest('[data-promo-change]') || e.target.closest('[data-promo-trigger]')) {
        e.preventDefault();
        e.stopPropagation();
        this._openSheet();
      }
    }

    _getBundleDiscountItems() {
      const script = this.querySelector('[data-bundle-discount-items]');
      if (!script) return [];

      try {
        const items = JSON.parse(script.textContent || '[]');
        return Array.isArray(items) ? items : [];
      } catch {
        return [];
      }
    }

    _shouldAnimate() {
      return this.dataset.showAnimation !== 'false';
    }

    static _markJustApplied() {
      sessionStorage.setItem('dcoded-promo-just-applied', '1');
    }

    _playApplyAnimation() {
      if (!this._shouldAnimate()) return;

      const pill = this.querySelector('.dcoded-promo__trigger--applied');
      if (pill) {
        pill.classList.add('dcoded-promo__trigger--celebrate');
        setTimeout(() => pill.classList.remove('dcoded-promo__trigger--celebrate'), 700);
      }

      const confettiWrap = this.querySelector('[data-promo-confetti]');
      if (confettiWrap) this._burstConfetti(confettiWrap);
    }

    _getApplyLabel() {
      return this.dataset.applyLabel || 'Apply';
    }

    _renderEligibleCodes() {
      const codesStr = (this.dataset.eligibleCodes || '').trim();
      const sheet = this._sheet || this.querySelector('[data-promo-sheet]');
      if (!sheet) return;

      const body = sheet.querySelector('.dcoded-promo__sheet-body');
      let section = sheet.querySelector('[data-promo-eligible-section]');
      let divider = sheet.querySelector('[data-promo-divider]');

      if (!section && body) {
        section = document.createElement('div');
        section.className = 'dcoded-promo__eligible';
        section.setAttribute('data-promo-eligible-section', '');
        section.innerHTML = '<p class="dcoded-promo__eligible-heading"></p><ul class="dcoded-promo__eligible-list" data-promo-eligible-list></ul>';
        body.insertBefore(section, body.firstChild);
      }

      if (!divider && body) {
        divider = document.createElement('div');
        divider.className = 'dcoded-promo__divider';
        divider.setAttribute('data-promo-divider', '');
        divider.innerHTML = '<span>or enter a code</span>';
        const form = body.querySelector('[data-promo-form]');
        if (form) body.insertBefore(divider, form);
        else body.appendChild(divider);
      }

      const heading = section?.querySelector('.dcoded-promo__eligible-heading');
      const list = section?.querySelector('[data-promo-eligible-list]');
      if (!list || !section) return;

      if (!codesStr) {
        section.hidden = true;
        if (divider) divider.hidden = true;
        list.innerHTML = '';
        return;
      }

      if (heading) {
        heading.textContent = this.dataset.eligibleHeading || 'AVAILABLE FOR YOU';
      }

      const applyLabel = this._getApplyLabel();
      list.innerHTML = '';
      codesStr.split('||').forEach((entry) => {
        const splitAt = entry.indexOf('::');
        const code = (splitAt === -1 ? entry : entry.slice(0, splitAt)).trim();
        const desc = (splitAt === -1 ? '' : entry.slice(splitAt + 2)).trim();
        if (!code) return;

        const li = document.createElement('li');
        li.className = 'dcoded-promo__eligible-item';
        li.dataset.eligibleCode = code;

        const icon = document.createElement('span');
        icon.className = 'dcoded-promo__eligible-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';

        const info = document.createElement('div');
        info.className = 'dcoded-promo__eligible-info';

        const codeEl = document.createElement('span');
        codeEl.className = 'dcoded-promo__eligible-code';
        codeEl.textContent = code;
        info.appendChild(codeEl);

        if (desc) {
          const descEl = document.createElement('span');
          descEl.className = 'dcoded-promo__eligible-desc';
          descEl.textContent = desc;
          info.appendChild(descEl);
        }

        const applyBtn = document.createElement('button');
        applyBtn.type = 'button';
        applyBtn.className = 'dcoded-promo__card-apply-btn';
        applyBtn.dataset.tapCode = code;
        applyBtn.textContent = applyLabel;

        li.appendChild(icon);
        li.appendChild(info);
        li.appendChild(applyBtn);
        list.appendChild(li);
      });

      section.hidden = list.children.length === 0;
      if (divider) divider.hidden = list.children.length === 0;
    }

    _ensureSheet() {
      this._reclaimSheetNodes();

      if (!this._overlay?.isConnected || !this._sheet?.isConnected) {
        this._resetSheetRefs();
        this._reclaimSheetNodes();
      }

      if (!this._overlay || !this._sheet) return;

      if (this._overlay.parentElement !== document.body) {
        document.body.appendChild(this._overlay);
      }
      if (this._sheet.parentElement !== document.body) {
        document.body.appendChild(this._sheet);
      }

      this._bindPortaledNodes(this._overlay, this._sheet);
      this._portaled = true;
    }

    _openSheet() {
      const drawer = this._getCartDrawer();
      if (drawer && !drawer.open) return;

      this._ensureSheet();
      if (!this._sheet || !this._overlay) return;

      activePromo = this;
      this._renderEligibleCodes();
      this._positionInDrawer();
      this._bindReposition();

      this._sheet.classList.add('dcoded-promo__sheet--open');
      this._overlay.classList.add('dcoded-promo__overlay--visible');

      const input = this._sheet.querySelector('.dcoded-promo__input');
      const error = this._sheet.querySelector('[data-promo-error]');
      if (input) {
        input.value = '';
        setTimeout(() => {
          this._positionInDrawer();
          input.focus();
        }, 300);
      }
      if (error) error.textContent = '';
    }

    _closeSheet() {
      this._unbindReposition();
      this._overlay?.classList.remove('dcoded-promo__overlay--visible');
      this._sheet?.classList.remove('dcoded-promo__sheet--open');
      this._resetPortaledStyles();
      this._restoreSheetToHost();

      if (!this._overlay?.isConnected && !this._sheet?.isConnected) {
        this._resetSheetRefs();
      }

      if (activePromo === this) activePromo = null;
    }

    _tapToUse(btn) {
      const code = btn.dataset.tapCode || '';
      if (!code) return;
      btn.classList.add('dcoded-promo__card-apply-btn--pulse');
      this._applyCode(code);
    }

    _applyFromInput() {
      const input = this._sheet?.querySelector('.dcoded-promo__input');
      const error = this._sheet?.querySelector('[data-promo-error]');
      if (!input) return;
      const code = input.value.trim();
      if (!code) return;
      if (error) error.textContent = '';
      this._applyCode(code);
    }

    _getSheetEl() {
      if (this._sheet?.isConnected) return this._sheet;
      return document.querySelector('[data-promo-sheet]');
    }

    _getErrorEl() {
      return this._getSheetEl()?.querySelector('[data-promo-error]') || null;
    }

    _getCartUpdateUrl() {
      if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root + 'cart/update.js';
      }
      return '/cart/update.js';
    }

    _getCartChangeUrl() {
      if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root + 'cart/change.js';
      }
      return '/cart/change.js';
    }

    async _fetchCart() {
      const root = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
      const res = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      return res.json();
    }

    _isPromoDiscountCode(cart, code) {
      const codeLower = normalizeCode(code);
      return cart.discount_codes?.some(
        (entry) => normalizeCode(entry.code) === codeLower && entry.applicable
      );
    }

    _isCartLevelAutomaticDiscount(cart, code) {
      const codeLower = normalizeCode(code);
      return cart.cart_level_discount_applications?.some(
        (entry) => normalizeCode(entry.title) === codeLower
      );
    }

    _isBundleDiscount(cart, code) {
      const codeLower = normalizeCode(code);
      return cart.items?.some((item) =>
        item.line_level_discount_allocations?.some(
          (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
        )
      );
    }

    _shouldRemoveAsBundle(cart, code) {
      if (this._isPromoDiscountCode(cart, code)) return false;
      if (this.dataset.appliedSource === 'bundle') return true;
      if (this._isBundleDiscount(cart, code)) return true;
      if (this._isCartLevelAutomaticDiscount(cart, code)) return true;

      const codeLower = normalizeCode(code);
      return cart.items?.some((item) => {
        const planName = normalizePlanName(item.selling_plan_allocation?.selling_plan?.name);
        return planName && (planName === codeLower || planName.includes(codeLower));
      });
    }

    _getPlansForLineItem(item) {
      if (item.plans?.length) return item.plans;
      return getPlansForVariant(item.variant_id);
    }

    _getBundleItemsForCode(cart, code, embeddedItems) {
      const codeLower = normalizeCode(code);
      let items = embeddedItems
        .map((item) => ({
          key: item.lineKey,
          variant_id: item.variantId,
          quantity: item.quantity,
          currentPlanId: item.currentPlanId || null,
          plans: item.plans || []
        }))
        .filter((item) => item.key);

      if (!items.length) {
        items = (cart.items || [])
          .filter((item) =>
            item.line_level_discount_allocations?.some(
              (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
            )
          )
          .map((item) => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            currentPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
            plans: []
          }));
      }

      if (!items.length) {
        items = (cart.items || [])
          .filter((item) => {
            const planName = normalizePlanName(item.selling_plan_allocation?.selling_plan?.name);
            return planName && (planName === codeLower || planName.includes(codeLower));
          })
          .map((item) => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            currentPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
            plans: []
          }));
      }

      if (!items.length && codeLower.includes('3 pack')) {
        items = (cart.items || [])
          .filter((item) =>
            normalizePlanName(item.selling_plan_allocation?.selling_plan?.name).includes('3 pack')
          )
          .map((item) => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            currentPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
            plans: []
          }));
      }

      return items.map((item) => ({
        ...item,
        plans: this._getPlansForLineItem(item)
      }));
    }

    _setRemoveLoading(isLoading) {
      this.querySelector('[data-promo-remove]')?.toggleAttribute('disabled', isLoading);
    }

    static _getDrawerSectionId() {
      const drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
      if (drawer?.dataset?.sectionId) return drawer.dataset.sectionId;

      const section = document.querySelector('.shopify-section[id*="cart-drawer"]');
      if (section?.id) return section.id.replace('shopify-section-', '');

      const promo = document.querySelector('dcoded-cart-promo[data-section-id]');
      return promo?.dataset?.sectionId || '';
    }

    _getSectionIds() {
      const sectionId = DcodedCartPromo._getDrawerSectionId();
      const ids = sectionId ? [sectionId] : [];

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: ids }
      }));
      return ids;
    }

    _isCodeApplied(cart, code) {
      const codeLower = normalizeCode(code);
      if (!codeLower) return false;

      if (cart.discount_codes?.some((entry) => normalizeCode(entry.code) === codeLower && entry.applicable)) {
        return true;
      }

      if (cart.cart_level_discount_applications?.some((entry) => normalizeCode(entry.title) === codeLower)) {
        return true;
      }

      return cart.items?.some((item) =>
        item.line_level_discount_allocations?.some(
          (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
        )
      );
    }

    _getDiscountAmount(cart, code) {
      const codeLower = normalizeCode(code);
      let amount = 0;

      cart.cart_level_discount_applications?.forEach((entry) => {
        if (normalizeCode(entry.title) === codeLower) {
          amount += entry.total_allocated_amount || 0;
        }
      });

      cart.items?.forEach((item) => {
        item.line_level_discount_allocations?.forEach((alloc) => {
          if (normalizeCode(alloc.discount_application?.title) === codeLower) {
            amount += alloc.amount || 0;
          }
        });
      });

      if (!amount && cart.total_discount > 0) {
        amount = cart.total_discount;
      }

      return amount;
    }

    _renderAppliedState(code, amount) {
      const inline = this.querySelector('.dcoded-promo__inline');
      if (!inline) return;

      const displayCode = code.toUpperCase();
      const displayAmount = formatMoney(amount || 0);

      this.dataset.appliedCode = displayCode;
      this.dataset.appliedAmount = String(amount || 0);
      this.dataset.appliedSource = this.dataset.appliedSource || 'code';

      inline.innerHTML = `
        <div class="dcoded-promo__trigger dcoded-promo__trigger--applied">
          <span class="dcoded-promo__trigger-left">
            <svg class="dcoded-promo__tag-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
            <span class="dcoded-promo__applied-code">${displayCode}</span>
            <span class="dcoded-promo__applied-amount">-${displayAmount}</span>
          </span>
          <span class="dcoded-promo__trigger-right">
            <button type="button" class="dcoded-promo__change-btn" data-promo-change>Change</button>
            <button type="button" class="dcoded-promo__remove-btn" data-promo-remove aria-label="Remove promo code" onclick="window.dcodedPromoRemove&&window.dcodedPromoRemove(this);return false;">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>
            </button>
          </span>
        </div>
        <div class="dcoded-promo__confetti-wrap" data-promo-confetti></div>
      `;

      const defaultDiscounts = this.closest('.cart-drawer__summary')?.querySelector('.cart-drawer__default-discounts');
      if (defaultDiscounts) defaultDiscounts.hidden = true;

    }

    _updateCheckoutPrice(totalPrice) {
      document.querySelectorAll('[data-cart-total-price], .cart-drawer__button-price, .cart-drawer__total-price').forEach((checkoutPrice) => {
        if (totalPrice != null) {
          checkoutPrice.textContent = formatMoney(totalPrice);
        }
      });
    }

    _getCartDrawerEl() {
      return document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    }

    _getLineFinalWithCartDiscount(item, cart) {
      let lineFinal = item.final_line_price;
      const itemsSubtotal = (cart.items || []).reduce((sum, entry) => sum + (entry.final_line_price || 0), 0);
      const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
        (sum, entry) => sum + (entry.total_allocated_amount || 0),
        0
      );

      if (cartDiscount > 0 && itemsSubtotal > 0) {
        const lineCartDiscount = Math.round((item.final_line_price * cartDiscount) / itemsSubtotal);
        lineFinal = item.final_line_price - lineCartDiscount;
      }

      return lineFinal;
    }

    _updateLineItemPrices(cart) {
      if (!cart?.items?.length) return;

      const drawer = this._getCartDrawerEl();

      cart.items.forEach((item) => {
        const lineItemEl = drawer?.querySelector(`line-item[data-line-key="${item.key}"]`);
        const priceEl = lineItemEl?.querySelector('[data-line-item-price]');
        if (!priceEl) return;

        const lineFinalWithCart = this._getLineFinalWithCartDiscount(item, cart);
        const hasTotalDiscount = lineFinalWithCart < item.original_line_price;

        if (!hasTotalDiscount) return;

        const quantity = item.quantity || 1;
        const unitOriginal = Math.round(item.original_line_price / quantity);
        const unitFinal = Math.round(lineFinalWithCart / quantity);

        priceEl.innerHTML = `
          <span class="dcoded-drawer-line-item__price-compare">${formatMoney(unitOriginal)}</span>
          <span class="dcoded-drawer-line-item__price-sale">${formatMoney(unitFinal)}</span>
        `;
      });
    }

    _setApplyLoading(isLoading) {
      const sheet = this._getSheetEl();
      const applyLabel = this._getApplyLabel();
      sheet?.querySelector('[data-promo-apply]')?.toggleAttribute('disabled', isLoading);
      sheet?.querySelectorAll('[data-tap-code]').forEach((btn) => {
        if (isLoading) {
          btn.classList.add('dcoded-promo__card-apply-btn--loading');
          btn.textContent = 'Applying...';
        } else {
          btn.classList.remove('dcoded-promo__card-apply-btn--pulse', 'dcoded-promo__card-apply-btn--loading');
          btn.textContent = applyLabel;
        }
      });
    }

    async _applyCode(code) {
      const error = this._getErrorEl();
      const trimmedCode = (code || '').trim();
      if (!trimmedCode) return;

      this._setApplyLoading(true);
      if (error) error.textContent = '';

      try {
        const cart = await this._fetchCart();
        const existingCodes = (cart.discount_codes || [])
          .filter((entry) => entry.applicable)
          .map((entry) => entry.code);

        if (existingCodes.map(normalizeCode).includes(normalizeCode(trimmedCode))) {
          if (error) error.textContent = 'This code is already applied.';
          return;
        }

        const allCodes = [...existingCodes, trimmedCode].join(',');
        const sectionIds = this._getSectionIds();
        const res = await fetch(this._getCartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: allCodes,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();

        if (!res.ok) {
          if (error) error.textContent = data.description || data.message || 'Could not apply this code. Please try again.';
          return;
        }

        const rejectedCode = data.discount_codes?.find(
          (entry) => normalizeCode(entry.code) === normalizeCode(trimmedCode) && entry.applicable === false
        );

        if (rejectedCode) {
          if (error) {
            error.textContent =
              'This code is not valid for your cart. It may be for first-time customers only, or may not work with your current items.';
          }
          return;
        }

        if (!this._isCodeApplied(data, trimmedCode)) {
          if (error) {
            error.textContent =
              'This code could not be applied. It may be for first-time customers only, or may not work with your current items.';
          }
          return;
        }

        const appliedAmount = this._getDiscountAmount(data, trimmedCode);
        const appliedCode = data.discount_codes?.find(
          (entry) => normalizeCode(entry.code) === normalizeCode(trimmedCode) && entry.applicable
        )?.code || trimmedCode.toUpperCase();

        if (this._shouldAnimate()) {
          DcodedCartPromo._markJustApplied();
        }

        this.dataset.appliedSource = 'code';
        this._renderAppliedState(appliedCode, appliedAmount);
        this._updateCheckoutPrice(data.total_price);
        this._updateLineItemPrices(data);
        this._closeSheet();
        DcodedCartPromo._refreshCartSections(data);
      } catch (err) {
        if (error) error.textContent = 'Something went wrong. Please try again.';
      } finally {
        this._setApplyLoading(false);
      }
    }

    async _changeCartLine(body) {
      const res = await fetch(this._getCartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Could not update cart line.');
      }

      return res.json();
    }

    _lineHasDiscount(cart, lineKey, code) {
      const codeLower = normalizeCode(code);
      const item = cart.items?.find((entry) => entry.key === lineKey);
      if (!item) return false;

      return item.line_level_discount_allocations?.some(
        (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
      );
    }

    _discountStillApplied(cart, code) {
      const codeLower = normalizeCode(code);

      if (
        cart.cart_level_discount_applications?.some(
          (entry) => normalizeCode(entry.title) === codeLower
        )
      ) {
        return true;
      }

      return cart.items?.some((item) =>
        item.line_level_discount_allocations?.some(
          (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
        )
      );
    }

    _getBundleChangeAttempts(item, code) {
      const codeLower = normalizeCode(code);
      const currentPlanId = item.currentPlanId || null;
      const plans = this._getPlansForLineItem(item);
      const singlePackPlanId =
        pickSinglePackPlanId(plans, currentPlanId) ||
        getSinglePackPlanId(item.variant_id, currentPlanId);
      const attempts = [];
      const addAttempt = (quantity, sellingPlan) => {
        const payload = {
          quantity,
          selling_plan: sellingPlan == null ? '' : sellingPlan
        };
        const duplicate = attempts.some(
          (entry) =>
            entry.quantity === payload.quantity && String(entry.selling_plan) === String(payload.selling_plan)
        );
        if (!duplicate) attempts.push(payload);
      };

      if (singlePackPlanId && String(singlePackPlanId) !== String(currentPlanId || '')) {
        addAttempt(item.quantity, singlePackPlanId);
      }

      const alternatePlan = plans.find((plan) => {
        if (currentPlanId && String(plan.id) === String(currentPlanId)) return false;
        const planName = normalizePlanName(plan.name);
        if (codeLower && (planName === codeLower || planName.includes(codeLower))) return false;
        return !planName.includes('3 pack');
      });
      if (alternatePlan) {
        addAttempt(item.quantity, String(alternatePlan.id));
      }

      if (currentPlanId) {
        addAttempt(item.quantity, '');
      }

      if (codeLower.includes('3 pack')) {
        const nonPackPlan = plans.find((plan) => !normalizePlanName(plan.name).includes('3 pack'));
        if (nonPackPlan && String(nonPackPlan.id) !== String(currentPlanId || '')) {
          addAttempt(item.quantity, String(nonPackPlan.id));
        }

        if (item.quantity > 1) {
          addAttempt(1, singlePackPlanId || '');
          addAttempt(1, '');
        } else {
          addAttempt(item.quantity, singlePackPlanId || '');
          addAttempt(item.quantity, '');
        }
      }

      if (!attempts.length) {
        addAttempt(item.quantity, '');
      }

      return attempts;
    }

    async _removeBundleDiscount(cart, code) {
      const codeLower = normalizeCode(code);
      const sectionIds = this._getSectionIds();
      const embeddedItems = this._getBundleDiscountItems();
      let itemsToUpdate = embeddedItems
        .map((item) => ({
          key: item.lineKey,
          variant_id: item.variantId,
          quantity: item.quantity,
          currentPlanId: item.currentPlanId || null,
          plans: item.plans || []
        }))
        .filter((item) => item.key);

      if (!itemsToUpdate.length) {
        itemsToUpdate = (cart.items || [])
          .filter((item) =>
            item.line_level_discount_allocations?.some(
              (alloc) => normalizeCode(alloc.discount_application?.title) === codeLower
            )
          )
          .map((item) => ({
            key: item.key,
            variant_id: item.variant_id,
            quantity: item.quantity,
            currentPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
            plans: []
          }));
      }

      if (!itemsToUpdate.length) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      let lastData = cart;
      let updated = false;
      const isLastItem = (index) => index === itemsToUpdate.length - 1;

      for (let i = 0; i < itemsToUpdate.length; i += 1) {
        const item = itemsToUpdate[i];
        const attempts = this._getBundleChangeAttempts(item, code);
        let itemUpdated = false;

        for (const attempt of attempts) {
          let current = lastData.items?.find((entry) => entry.key === item.key);
          if (!current) {
            current = lastData.items?.find((entry) => entry.variant_id === item.variant_id);
            if (current) item.key = current.key;
          }
          if (!current) break;

          const body = {
            id: current.key,
            quantity: attempt.quantity,
            selling_plan: attempt.selling_plan
          };

          if (isLastItem(i) && sectionIds.length) {
            body.sections = sectionIds.join(',');
            body.sections_url = window.location.pathname;
          }

          lastData = await this._changeCartLine(body);

          if (!this._discountStillApplied(lastData, code)) {
            itemUpdated = true;
            updated = true;
            break;
          }
        }

        if (!itemUpdated) {
          console.error('Could not remove bundle discount for line', item.key);
          DcodedCartPromo._refreshCartSections(lastData);
        }
      }

      if (!updated) {
        await DcodedCartPromo._forceRefreshDrawer();
        throw new Error('Could not remove bundle discount.');
      }

      delete this.dataset.appliedCode;
      delete this.dataset.appliedAmount;
      delete this.dataset.appliedSource;
      this._updateCheckoutPrice(lastData.total_price);
      DcodedCartPromo._refreshCartSections(lastData);
    }

    async _removeCode() {
      const currentCode = this.dataset.appliedCode;
      if (!currentCode || this._removing) return;

      this._removing = true;
      this._setRemoveLoading(true);

      try {
        const cart = await this._fetchCart();
        const isBundle = this._shouldRemoveAsBundle(cart, currentCode);

        if (isBundle) {
          await this._removeBundleDiscount(cart, currentCode);
          return;
        }

        const existingCodes = (cart.discount_codes || [])
          .filter((entry) => entry.applicable)
          .map((entry) => entry.code);

        const codeLower = normalizeCode(currentCode);
        const idx = existingCodes.findIndex((c) => normalizeCode(c) === codeLower);
        if (idx !== -1) existingCodes.splice(idx, 1);

        const res = await fetch(this._getCartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: existingCodes.join(','),
            sections: this._getSectionIds().join(','),
            sections_url: window.location.pathname
          })
        });

        const data = await res.json();
        DcodedCartPromo._refreshCartSections(data);
      } catch (err) {
        console.error('Failed to remove discount', err);
        await DcodedCartPromo._forceRefreshDrawer();
      } finally {
        this._removing = false;
        this._setRemoveLoading(false);
      }
    }

    static async _forceRefreshDrawer() {
      return new Promise((resolve) => {
        const onRefreshed = () => {
          document.removeEventListener('cart-drawer:refreshed', onRefreshed);
          resolve();
        };

        document.addEventListener('cart-drawer:refreshed', onRefreshed);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          document.removeEventListener('cart-drawer:refreshed', onRefreshed);
          resolve();
        }, 5000);
      });
    }

    static _refreshCartSections(data) {
      const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
      const drawerWasOpen = Boolean(cartDrawer?.open);
      const sectionId = DcodedCartPromo._getDrawerSectionId();
      const hasSections = Boolean(sectionId && data.sections && data.sections[sectionId]);

      if (hasSections) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'promo:update',
            cart: data
          }
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      if (drawerWasOpen && cartDrawer && !cartDrawer.open) {
        cartDrawer.show();
      }

      document.dispatchEvent(new CustomEvent('dcoded-cart-drawer-refreshed'));
    }

    _resetTapButtons() {
      this._setApplyLoading(false);
    }

    _burstConfetti(wrap) {
      const colors = ['#22c55e', '#4ade80', '#86efac', '#bbf7d0', '#dcfce7', '#16a34a', '#15803d', '#a7f3d0'];
      const shapes = ['circle', 'heart', 'rect'];

      for (let i = 0; i < 35; i++) {
        const piece = document.createElement('span');
        piece.classList.add('confetti-piece');

        const shape = shapes[Math.floor(Math.random() * shapes.length)];
        const color = colors[Math.floor(Math.random() * colors.length)];
        const left = Math.random() * 100;
        const delay = Math.random() * 0.5;
        const rotate = (Math.random() - 0.5) * 720;
        const size = 5 + Math.random() * 6;

        piece.style.left = left + '%';
        piece.style.animationDelay = delay + 's';
        piece.style.setProperty('--confetti-rotate', rotate + 'deg');

        if (shape === 'circle') {
          piece.style.width = size + 'px';
          piece.style.height = size + 'px';
          piece.style.borderRadius = '50%';
          piece.style.background = color;
        } else if (shape === 'heart') {
          piece.innerHTML = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 10 10"><path d="M5 9 C3 7,0 5,0 3 A2 2,0,0,1,5 3 A2 2,0,0,1,10 3 C10 5,7 7,5 9Z" fill="' + color + '"/></svg>';
        } else {
          piece.style.width = size * 0.6 + 'px';
          piece.style.height = size + 'px';
          piece.style.background = color;
          piece.style.borderRadius = '1px';
        }

        wrap.appendChild(piece);
      }

      setTimeout(() => {
        wrap.querySelectorAll('.confetti-piece').forEach((p) => p.remove());
      }, 2500);
    }

    static _shouldClearDiscountCodes(cart) {
      const codes = cart?.discount_codes || [];
      if (!codes.length) return false;

      const hasItems = (cart.item_count || 0) > 0 || (cart.items?.length || 0) > 0;
      if (!hasItems) return true;

      return !codes.some((entry) => entry.applicable);
    }

    static async _clearInactiveDiscountCodes(cart, baseEvent) {
      if (baseEvent === 'promo:update' || DcodedCartPromo._promoSyncInProgress) return cart;
      if (!DcodedCartPromo._shouldClearDiscountCodes(cart)) return cart;

      DcodedCartPromo._promoSyncInProgress = true;

      try {
        const sectionId = DcodedCartPromo._getDrawerSectionId();
        const sectionIds = sectionId ? [sectionId] : [];

        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionIds }
        }));

        const root = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
        const res = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: '',
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        });

        if (!res.ok) return cart;

        const data = await res.json();
        DcodedCartPromo._refreshCartSections(data);
        return data;
      } catch (err) {
        console.error('Failed to clear inactive discount codes', err);
        return cart;
      } finally {
        DcodedCartPromo._promoSyncInProgress = false;
      }
    }
  }

  DcodedCartPromo._promoSyncInProgress = false;

  if (!customElements.get('dcoded-cart-promo')) {
    customElements.define('dcoded-cart-promo', DcodedCartPromo);
  }

  const updateDrawerLineItemPrices = (cart) => {
    if (!cart?.items?.length) return;

    const drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (!drawer) return;

    const itemsSubtotal = cart.items.reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
      (sum, entry) => sum + (entry.total_allocated_amount || 0),
      0
    );

    cart.items.forEach((item) => {
      const lineItemEl = drawer.querySelector(`line-item[data-line-key="${item.key}"]`);
      const priceEl = lineItemEl?.querySelector('[data-line-item-price]');
      if (!priceEl) return;

      let lineFinalWithCart = item.final_line_price;
      if (cartDiscount > 0 && itemsSubtotal > 0) {
        const lineCartDiscount = Math.round((item.final_line_price * cartDiscount) / itemsSubtotal);
        lineFinalWithCart = item.final_line_price - lineCartDiscount;
      }

      if (lineFinalWithCart >= item.original_line_price) return;

      const quantity = item.quantity || 1;
      const unitOriginal = Math.round(item.original_line_price / quantity);
      const unitFinal = Math.round(lineFinalWithCart / quantity);

      priceEl.innerHTML = `
        <span class="dcoded-drawer-line-item__price-compare">${formatMoney(unitOriginal)}</span>
        <span class="dcoded-drawer-line-item__price-sale">${formatMoney(unitFinal)}</span>
      `;
    });
  };

  document.addEventListener('cart-drawer:refreshed', () => {
    fetch((typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then((res) => res.json())
      .then(updateDrawerLineItemPrices)
      .catch(() => {});
  });

  document.documentElement.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart;
    if (!cart) return;

    const baseEvent = event.detail?.baseEvent;
    DcodedCartPromo._clearInactiveDiscountCodes(cart, baseEvent);

    if (!cart.cart_level_discount_applications?.length) return;
    requestAnimationFrame(() => updateDrawerLineItemPrices(cart));
  });

  const bootstrapPromoDiscountSync = async () => {
    try {
      const root = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((res) => res.json());
      await DcodedCartPromo._clearInactiveDiscountCodes(cart, 'init');
    } catch {
      /* ignore */
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapPromoDiscountSync);
  } else {
    bootstrapPromoDiscountSync();
  }

  const getPromoFromPortaled = (node) => {
    const overlay = node?.closest?.('[data-promo-overlay]');
    const sheet = node?.closest?.('[data-promo-sheet]');
    return overlay?._dcodedPromo || sheet?._dcodedPromo || activePromo || getActivePromo();
  };

  document.addEventListener('click', (e) => {
    const promo = getPromoFromNode(e.target) || findInComposedPath(e, 'dcoded-cart-promo');
    if (promo) return;

    const portaledPromo = getPromoFromPortaled(e.target);

    if (findInComposedPath(e, '[data-promo-overlay]') || e.target.closest('[data-promo-overlay]')) {
      e.preventDefault();
      e.stopPropagation();
      portaledPromo?._closeSheet();
      return;
    }
    if (findInComposedPath(e, '[data-promo-close]') || e.target.closest('[data-promo-close]')) {
      e.preventDefault();
      e.stopPropagation();
      portaledPromo?._closeSheet();
      return;
    }
    const tapCode = findInComposedPath(e, '[data-tap-code]') || e.target.closest('[data-tap-code]');
    if (tapCode) {
      e.preventDefault();
      e.stopPropagation();
      portaledPromo?._tapToUse(tapCode);
      return;
    }
    if (findInComposedPath(e, '[data-promo-apply]') || e.target.closest('[data-promo-apply]')) {
      e.preventDefault();
      e.stopPropagation();
      portaledPromo?._applyFromInput();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('.dcoded-promo__input');
    if (!input) return;
    e.preventDefault();
    const promo = getPromoFromNode(input) || getPromoFromPortaled(input);
    promo?._applyFromInput();
  });

})();

